import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "fill-height pa-0 mt-2",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptTitle'),
      "open": _vm.deviceTypeChangedPrompt,
      "buttons": [{
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptReset'),
        emit: 'reset'
      }, {
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptButton'),
        color: _vm.color,
        emit: 'set'
      }]
    },
    on: {
      "reset": function ($event) {
        _vm.dtwin.data.virtualDevice.deviceTypeId = _vm.savedDeviceTypeId;
        _vm.dtwin.data.virtualDevice.deviceDriverId = _vm.savedDeviceDriverId;
        _vm.deviceTypeChangedPrompt = false;
        _vm.isUnlocked = false;
      },
      "set": function ($event) {
        _vm.deviceTypeChangedPrompt = false;
        _vm.isUnlocked = true;
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptText'))
    }
  })]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeSyncPromptTitle'),
      "open": _vm.deviceTypeSyncPrompt,
      "buttons": [{
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptReset'),
        emit: 'reset'
      }, {
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptButton'),
        color: _vm.color,
        emit: 'set'
      }]
    },
    on: {
      "reset": function ($event) {
        _vm.deviceTypeSyncPrompt = false;
      },
      "set": function ($event) {
        _vm.dtwin.data.virtualDevice[_vm.isDeviceDriverActive ? 'deviceDriverSync' : 'deviceTypeSync'] = true;
        _vm.deviceTypeSyncPrompt = false;
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeSyncPromptText', {
        parserType: _vm.$i18n_t(_vm.isDeviceDriverActive ? 'DigitalTwin.VirtualDevice.props.deviceDriver' : 'DigitalTwin.VirtualDevice.props.deviceType')
      }))
    }
  })]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTemplateUnlinkPromptTitle'),
      "open": _vm.deviceTemplateUnlinkPrompt,
      "buttons": [{
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTemplateUnlinkPromptCancel'),
        emit: 'reset'
      }, {
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTemplateUnlinkPromptButton'),
        color: _vm.color,
        emit: 'set',
        dataCy: 'unlink'
      }]
    },
    on: {
      "reset": function ($event) {
        _vm.deviceTemplateUnlinkPrompt = false;
      },
      "set": function ($event) {
        _vm.deviceTemplateUnlinkPrompt = false;
        _vm.unlinkDeviceTemplate();
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTemplateUnlinkPromptText'))
    }
  })]), !_vm.$vuetify.breakpoint.smAndDown ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.isDeviceDriverActive ? [_vm.getTypeNameOrDriverName ? [_c('router-link', {
    attrs: {
      "to": `/virtual-device-drivers/${_vm.deviceDriverId}`
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "data-cy": "device_driver_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.props.deviceDriver')) + ": " + _vm._s(_vm.getTypeNameOrDriverName) + "\n              "), _c(VIcon, {
    staticClass: "mb-1",
    attrs: {
      "color": _vm.color,
      "small": ""
    }
  }, [_vm._v("far fa-external-link-alt")])], 1)])] : [_c('h5', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.noDeviceDriverChosen')) + "\n          ")])]] : [_vm.getTypeNameOrDriverName ? [_c('router-link', {
    attrs: {
      "to": `/niota-classic/device-types/${_vm.deviceTypeId}/details`
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.props.deviceType')) + ": " + _vm._s(_vm.getTypeNameOrDriverName) + "\n            ")])])] : [_c('h5', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.noDeviceTypeChosen')))])]]], 2) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": _vm.$vuetify.breakpoint.smAndDown ? 7 : 12,
      "md": _vm.$vuetify.breakpoint.smAndDown ? 12 : 4,
      "align": _vm.$vuetify.breakpoint.smAndDown ? undefined : 'right'
    }
  }, [_c('div', [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.createdAt')) + " " + _vm._s(_vm.relativeTime(_vm.dtwin.createdAt)) + ",\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.lastSeen')) + " " + _vm._s(_vm.relativeTime(_vm.lastRawStateUpdate)) + "\n        "), _vm.totalUplinkPacketCount !== null ? [_c('br'), _vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.totalPacketStatistic')) + "\n          "), _vm.totalUplinkPacketCount !== null ? [_c('span', {
    style: `color: ${_vm.customColor};`
  }, [_vm._v("↑")]), _vm._v("\n            " + _vm._s(_vm.totalUplinkPacketCount) + "\n          ")] : _vm._e()] : _vm._e()], 2)]), _c(VCol, {
    attrs: {
      "cols": "5"
    }
  }, [_c('core-date-time-picker-flat', {
    attrs: {
      "isRange": "",
      "initialRange": "now-7d",
      "to": _vm.timeRange.to
    },
    on: {
      "date:picked": _vm.setTimeRange
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_vm.rawState.id && _vm.dtwin.id && _vm.bridgeManifest ? _c('core-virtual-device-packet-history-viewer', {
    attrs: {
      "height": 360,
      "bridgeManifest": _vm.bridgeManifest,
      "rawStateId": _vm.rawState.id,
      "virtualDeviceId": _vm.dtwin.id,
      "queryStartDate": _vm.timeRange.from ? new Date(_vm.timeRange.from * 1000).toISOString() : null,
      "queryEndDate": _vm.timeRange.to ? new Date(_vm.timeRange.to * 1000).toISOString() : null,
      "isAutoRefresh": _vm.timeRange.isAutoRefresh,
      "isReset": true
    },
    on: {
      "click": e => _vm.clickRowHandler(e),
      "csv-export": _vm.noop
    }
  }) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('core-virtual-device-packet-visualizations', {
    attrs: {
      "height": 360,
      "data": _vm.currentPacket,
      "parsedData": _vm.currentParsedPacket,
      "shouldShowParsedData": _vm.deviceTypeHasParser || _vm.deviceDriverHasDefaultParser
    }
  })], 1)], 1), !_vm.isLoadingPacketMetrics && _vm.packetsMetricsDataComp.common.labels.length > 0 ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.timeRange.from ? _c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.packetsReceived')))]) : _c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.packetsReceivedL2m')))]), _c(VCard, {
    staticClass: "mb-1",
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.packetsMetricsDataComp,
      "options": _vm.packetMetricsOptions
    }
  })], 1)], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": !_vm.panelsStartExpanded ? 0 : null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.properties')) + "\n          ")]), _c(VExpansionPanelContent, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c('custom-text-field-clipboard', {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.props.deviceId'),
      "value": _vm.get(_vm.dtwin, 'properties.bridge.deviceData.device_id'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "data-cy": "device_id"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c(VCombobox, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "items": _vm.operationalStatusItems,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.hasTwinManagePermission,
      "return-object": false,
      "hide-details": "",
      "data-cy": "select_operationalStatus"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm.operationalStatus[parseInt(data.item)] ? [_vm._v("\n                      " + _vm._s(_vm.operationalStatus[parseInt(data.item)]) + "\n                    ")] : [_vm._v("\n                      " + _vm._s(data.item) + "\n                    ")]];
      }
    }]),
    model: {
      value: _vm.dtwin.data.virtualDevice.operationalStatus,
      callback: function ($$v) {
        _vm.$set(_vm.dtwin.data.virtualDevice, "operationalStatus", $$v);
      },
      expression: "dtwin.data.virtualDevice.operationalStatus"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "4",
      "md": "12",
      "sm": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_vm.isDeviceDriverActive ? _c(VAutocomplete, {
    staticClass: "mr-2",
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "value": _vm.deviceDriverId,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.deviceDriver'),
      "items": _vm.deviceDriver ? [_vm.deviceDriver, ..._vm.deviceDriversSearchResult] : _vm.deviceDriversSearchResult,
      "loading": _vm.isSearchingDeviceDrivers,
      "search-input": _vm.deviceDriversSearchInput,
      "hide-no-data": "",
      "hide-selected": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.hasTwinManagePermission || !_vm.isUnlocked,
      "item-text": "title",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "data-cy": "select_device_driver"
    },
    on: {
      "input": _vm.changeActiveDeviceDriverId,
      "update:searchInput": function ($event) {
        _vm.deviceDriversSearchInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.deviceDriversSearchInput = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n                      " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                    ")];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                          " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                        ")])], 1)];
      }
    }], null, false, 1044425832)
  }) : _c(VAutocomplete, {
    staticClass: "mr-2",
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.title'),
      "items": _vm.deviceTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.hasTwinManagePermission || !_vm.isUnlocked,
      "item-text": "title",
      "item-value": "id",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n                      " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                    ")];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                          " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                        ")])], 1)];
      }
    }]),
    model: {
      value: _vm.dtwin.data.virtualDevice.deviceTypeId,
      callback: function ($$v) {
        _vm.$set(_vm.dtwin.data.virtualDevice, "deviceTypeId", $$v);
      },
      expression: "dtwin.data.virtualDevice.deviceTypeId"
    }
  }), _vm.isDeviceDriverActive ? [_vm.hasTwinManagePermission && !_vm.isUnlocked ? _c('core-button', {
    attrs: {
      "disabled": _vm.isCreatedByTemplate,
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceDriverChangePromptButton'),
      "prepend-icon": "fa-sync-alt"
    },
    on: {
      "click": function ($event) {
        _vm.deviceTypeSyncPrompt = true;
      }
    }
  }) : _vm._e(), _vm.hasTwinManagePermission && !_vm.isUnlocked ? _c('core-button', {
    staticClass: "mr-0",
    attrs: {
      "disabled": _vm.isCreatedByTemplate,
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceDriverChangePromptButton'),
      "prepend-icon": "fa-lock-open"
    },
    on: {
      "click": function ($event) {
        _vm.deviceTypeChangedPrompt = true;
      }
    }
  }) : _vm._e()] : [_vm.hasTwinManagePermission && !_vm.isUnlocked && !!_vm.savedDeviceTypeId ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptButton'),
      "prepend-icon": "fa-sync-alt"
    },
    on: {
      "click": function ($event) {
        _vm.deviceTypeSyncPrompt = true;
      }
    }
  }) : _vm._e(), _vm.hasTwinManagePermission && !_vm.isUnlocked && !!_vm.savedDeviceTypeId ? _c('core-button', {
    staticClass: "mr-0",
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceTypeChangePromptButton'),
      "prepend-icon": "fa-lock-open"
    },
    on: {
      "click": function ($event) {
        _vm.deviceTypeChangedPrompt = true;
      }
    }
  }) : _vm._e()]], 2)])], 1), _c(VRow, [_c(VCol, {
    staticClass: "vdevice-add-wizard",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceGroups'),
      "items": _vm.deviceGroups,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.hasTwinManagePermission,
      "hide-details": "",
      "multiple": "",
      "small-chips": "",
      "data-cy": "select_groups"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function ({
        attrs,
        item
      }) {
        return [_c(VChip, _vm._b({
          attrs: {
            "small": "",
            "disabled": item.disabled,
            "data-cy": "tag-chip"
          }
        }, 'v-chip', attrs, false), [_vm._v("\n                      " + _vm._s(_vm.isCreatedByTemplate ? item.value : item) + "\n                      "), _vm.templateGroups.includes(item.value) ? [_vm._v("\n                         \n                        "), _c(VIcon, {
          attrs: {
            "size": "small"
          }
        }, [_vm._v("fa-sitemap")])] : _vm._e()], 2)];
      }
    }]),
    model: {
      value: _vm.dtwin.properties.groups,
      callback: function ($$v) {
        _vm.$set(_vm.dtwin.properties, "groups", $$v);
      },
      expression: "dtwin.properties.groups"
    }
  })], 1), _c(VCol, {
    staticClass: "vdevice-add-wizard",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.createNewGroup'),
      "disabled": !_vm.hasTwinManagePermission,
      "hide-details": "",
      "data-cy": "add_new_device_group"
    },
    on: {
      "keydown": _vm.restrictCharacters,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.addNewDeviceGroup.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Common.addNew'),
            "color": _vm.color,
            "disabled": _vm.newDeviceGroup.trim() === '',
            "prepend-icon": "fa-plus",
            "data-cy": "add_new_device_group_btn"
          },
          on: {
            "click": _vm.addNewDeviceGroup
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.newDeviceGroup,
      callback: function ($$v) {
        _vm.newDeviceGroup = $$v;
      },
      expression: "newDeviceGroup"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "4",
      "md": "12",
      "sm": "12"
    }
  }, [_vm.isCreatedByTemplate ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c(VTextField, {
    staticClass: "mr-2",
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deviceTemplate'),
      "value": _vm.get(_vm.deviceTemplate, 'title'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "disabled": "",
      "data-cy": "vd_template"
    }
  }), [_vm.hasTwinManagePermission ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.buttons.unlink'),
      "disabled": !_vm.hasTwinManagePermission,
      "data-cy": "unlink_button",
      "prepend-icon": "fa-unlink"
    },
    on: {
      "click": function ($event) {
        _vm.deviceTemplateUnlinkPrompt = true;
      }
    }
  }) : _vm._e()]], 2) : _vm._e()])], 1)], 1)], 1)], 1)], 1)], 1), _vm.$slots['external'] ? [_c(VRow, [_vm._t("external")], 2)] : _vm._e(), _vm.hasTwinManagePermission && _vm.downlinkMethodFields.length ? _c(VRow, [_c(VForm, {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.sendDownlinkPacket.apply(null, arguments);
      }
    },
    model: {
      value: _vm.downlinkFormValid,
      callback: function ($$v) {
        _vm.downlinkFormValid = $$v;
      },
      expression: "downlinkFormValid"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": _vm.panelsStartExpanded ? 0 : null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.downlink')) + "\n            ")]), _c(VExpansionPanelContent, [_vm.predefinedDownlinks.length > 0 ? _c(VAutocomplete, {
    staticClass: "mb-4",
    attrs: {
      "items": _vm.predefinedDownlinks,
      "item-text": "name",
      "item-value": "id",
      "label": "Predefined Downlinks",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "clearable": "",
      "return-object": ""
    },
    on: {
      "change": _vm.selectPredefinedDownlink
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.name) + " (Port: " + _vm._s(data.item.port) + ")")]), _c(VListItemSubtitle, [_vm._v("Payload: " + _vm._s(data.item.payload))])], 1)];
      }
    }], null, false, 1466096437)
  }) : _vm._e(), _c(VRow, [_vm._l(_vm.downlinkMethodFields, function (configKey) {
    return _c(VCol, {
      key: `sendlink_config_item_${configKey}_${_vm.downlinksRenderCacheBuster}`,
      staticClass: "my-1 py-1",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c('core-tenant-bridge-config-field', {
      attrs: {
        "fieldConfig": _vm.downlinkMethodParameters[configKey],
        "bridgeConfig": {},
        "bridgeConfigId": _vm.connectedBridge.id,
        "bridgeType": _vm.connectedBridge.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeManifest,
        "bridgeHasValidParametersStrict": false,
        "bridgeHasValidParameters": "",
        "brigdeHasError": false
      },
      model: {
        value: _vm.downlinkParameters[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.downlinkParameters, configKey, $$v);
        },
        expression: "downlinkParameters[configKey]"
      }
    })], 1);
  }), _c(VCol, {
    attrs: {
      "align": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "disabled": !_vm.downlinkFormValid,
      "color": _vm.color,
      "type": "submit"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.sendDownlink')) + "\n                  ")])], 1)], 2)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": _vm.panelsStartExpanded ? 0 : null
    }
  }, [_c(VExpansionPanel, {
    attrs: {
      "data-cy": "tab-connector-data"
    }
  }, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.connectorData')) + "\n          ")]), _c(VExpansionPanelContent, [_vm.connectedBridge && _vm.connectedBridge.id ? _c(VRow, [!_vm.bridgeUpdateMethod ? _c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "danger--text"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.readonlyDeviceData')))])]) : _vm._e(), _c(VCol, {
    staticClass: "my-1 py-1 vdevice-add-wizard",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": `${_vm.connectedBridge.name} (ID: ${_vm.connectedBridge.id})`,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": "",
      "hide-details": "",
      "data-cy": "connector_name"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('router-link', {
          attrs: {
            "to": `/connectors/edit/${_vm.connectedBridge.tenantId}/${_vm.connectedBridge.id}`
          }
        }, [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[_vm.connectedBridge.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[_vm.connectedBridge.type],
            "alt": _vm.connectedBridge.name,
            "title": _vm.connectedBridge.name
          }
        }) : _vm._e()])], 1)], 1)];
      },
      proxy: true
    }], null, false, 2816579897)
  })], 1), _vm._l(_vm.bridgeOutputFieldKeys, function (configKey, j) {
    return _c(VCol, {
      key: `bridge_config_item_${j}`,
      staticClass: "my-1 py-1",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_vm.bridgeUpdateMethod || !_vm.bridgeReadMethod ? _c('core-tenant-bridge-config-field', {
      attrs: {
        "fieldConfig": _vm.bridgeCreateParameters[configKey],
        "bridgeConfig": {},
        "bridgeConfigId": _vm.connectedBridge.id,
        "bridgeType": _vm.connectedBridge.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeManifest,
        "bridgeHasValidParametersStrict": false,
        "disabled": _vm.bridgeUpdateMethod === null || _vm.bridgeCreateParameters[configKey].disableUpdate || _vm.useExternalData && !_vm.deviceDataFromBridge || _vm.bridgeCreateParameters[configKey].predefineInTemplates && _vm.dtwin.deviceTemplateId || _vm.isPermissionBasedField(_vm.bridgeCreateParameters, configKey) && !_vm.hasRequiredPermission(_vm.getRequiredPermission(_vm.bridgeCreateParameters, configKey), _vm.hasVirtualDeviceKeyReaderPermission),
        "dependsOnFieldValue": _vm.getDependsOnFieldValue(_vm.bridgeCreateParameters, configKey, _vm.dtwin.properties.bridge.deviceData),
        "bridgeHasValidParameters": "",
        "isCreatedByTemplate": _vm.isCreatedByTemplate,
        "hasVirtualDeviceKeyReaderPermission": _vm.hasVirtualDeviceKeyReaderPermission
      },
      on: {
        "changedBridgeParams": _vm.deviceConfigChanged
      },
      model: {
        value: _vm.dtwin.properties.bridge.deviceData[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.dtwin.properties.bridge.deviceData, configKey, $$v);
        },
        expression: "dtwin.properties.bridge.deviceData[configKey]"
      }
    }) : _c('core-tenant-bridge-config-field', {
      attrs: {
        "fieldConfig": _vm.bridgeCreateParameters[configKey],
        "bridgeConfig": {},
        "bridgeConfigId": _vm.connectedBridge.id,
        "bridgeType": _vm.connectedBridge.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeManifest,
        "bridgeHasValidParametersStrict": false,
        "dependsOnFieldValue": _vm.getDependsOnFieldValue(_vm.bridgeCreateParameters, configKey, _vm.dtwin.properties.bridge.deviceData),
        "bridgeHasValidParameters": "",
        "disabled": ""
      },
      model: {
        value: _vm.deviceDataFromBridge[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.deviceDataFromBridge, configKey, $$v);
        },
        expression: "deviceDataFromBridge[configKey]"
      }
    })], 1);
  })], 2) : _c(VRow, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "danger--text"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.connectorDeleted')))])])], 1)], 1)], 1)], 1)], 1)], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };